import React, { PropTypes } from 'react';

import Button from '../../../Button';
import Close from '../../../Close';
import Container from '../../../Container';
import EventSearchName from '../../../../containers/EventSearchName';
import EventSearchFilters from '../../../../containers/EventSearchFilters';

import { srOnly } from '../../../../base-styles/mixins.module.css';
import {
  back,
  button,
  closeContainer,
  conjunctive,
  eventSearchFilters,
  eventSearchFiltersContainer,
  eventSearchFiltersContainerExpanded,
  expandedFilters,
  filters,
  hideButtonMD,
  link,
  searchContainer,
  searchIcon,
  eventInfoContainer,
  typeContainer,
  typeContainerExpanded,
  mobileContainer,
} from './styles.module.css';

const HeaderMenuSearch = ({
  children,
  expanded,
  hideName,
  hideType,
  search,
  mobile,
  searchByName,
  searchByType,
  toggleField,
  toggleSearch,
  onEsc,
  onChange,
  onSelect,
  onSubmit,
  onSearchCloseClick,
  showAllFields,
}) => (
  <div>
    {search ?
      <div className={eventInfoContainer}>
        <div className={closeContainer}>
          {expanded && !mobile ?
            <div className={back} onClick={showAllFields}>
              <span className={srOnly}>Back</span>
            </div>
          :
            <Close onClose={onSearchCloseClick} link />}
        </div>

        {mobile &&
          <div className={mobileContainer}>
            {(!expanded || (expanded && searchByType)) ?
              <div>
                <EventSearchFilters onChange={onChange} headerSearch isOpen conversational className={filters} />
                <Button className={button} onClick={onSubmit} primary>{'Find events'}</Button>
                <a id="searchByName" className={link} onClick={toggleField}>Search by name</a>
              </div>
            :
              <div>
                <EventSearchName
                  onSelect={toggleSearch}
                  onEsc={onEsc}
                  searchingByName={searchByName}
                />
                <a id="searchByType" className={link} onClick={toggleField}>Search by type</a>
              </div>
            }
          </div>
        }

        {!mobile &&
          // Show both options.
          <Container className={searchContainer}>
            {!hideName &&
              <EventSearchName
                onSelect={toggleSearch}
                toggleField={toggleField}
                onEsc={onEsc}
                searchingByName={searchByName}
              />}
            {!expanded &&
              <div className={conjunctive}>or</div>}
            {(searchByType || !hideType) &&
              <div
                className={hideName ? typeContainerExpanded : typeContainer}
                onClick={toggleField}
              ><div
                id="searchByType"
                name="searchByType"
                onClick={toggleField}
                className={hideName ?
                eventSearchFiltersContainerExpanded : eventSearchFiltersContainer}
              >
                <EventSearchFilters
                  className={hideName ? expandedFilters : eventSearchFilters}
                  onChange={onChange}
                  onSelect={onSelect}
                  headerSearch
                  isOpen
                  conversational
                />
                <Button className={expanded ? button : hideButtonMD} onClick={onSubmit} primary>{'Search'}</Button></div>
              </div>}
          </Container>}
      </div>
    :
      <div onClick={toggleSearch} className={searchIcon}>{children}</div>}
  </div>
);

export default HeaderMenuSearch;

HeaderMenuSearch.propTypes = {
  /**
   * Child contents of search launcher.
   */
  children: PropTypes.shape(),
  /**
   * If field is expanded, hide unused fields, buttons and/or words.
   */
  expanded: PropTypes.bool,
  /**
   * Bool to determine whether component has been launched from mobile nav.
   */
  mobile: PropTypes.bool,
  /**
   * Bool to determine whether search is visible or not.
   */
  search: PropTypes.bool,
  /**
   * Bool to expand searching by name field upon selection.
   */
  searchByName: PropTypes.bool,
  /**
   * Bool to expand searching by type fields upon selection.
   */
  searchByType: PropTypes.bool,
  /**
   * Function to open or close search.
   */
  toggleSearch: PropTypes.func,
  /**
   * Function to be called on pressing ESC.
   */
  onEsc: PropTypes.func,
  /**
   * Function to
   */
  toggleField: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onSearchCloseClick: PropTypes.func,
  hideName: PropTypes.bool,
  hideType: PropTypes.bool,
  onSelect: PropTypes.func,
  showAllFields: PropTypes.func,
};

HeaderMenuSearch.defaultProps = {
  children: undefined,
  expanded: false,
  hideName: false,
  hideType: false,
  mobile: false,
  search: false,
  searchByName: false,
  searchByType: false,
  showAllFields: () => {},
  toggleField: () => {},
  toggleSearch: () => {},
  onEsc: () => {},
  onChange: () => {},
  onSelect: () => {},
  onSubmit: () => {},
  onSearchCloseClick: () => {},
};



// WEBPACK FOOTER //
// ./app/src/components/HeaderMenu/components/HeaderMenuSearch/index.jsx